/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.
*/

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import './CaptionBox.css'

const CaptionBox = (props) => {
  const { content, isDisplay } = props;

  if (isDisplay) {
    return (
      <div className="caption-box" style={{display: isDisplay ? '' : 'none'}}>
        <div className={'caption-title'} data-key={ content.title.dataKey }>
          <i aria-hidden={true} className="icon icon-circle-fill-information">{}</i>{ content.title.text }
        </div>
        <ul>
          { content.captionArray && content.captionArray.map((item, index)=> {
            return (
              <li className="font-body1"
                  key={`caption-list-${index}`}
                  data-key={ item.dataKey }
                  dangerouslySetInnerHTML={ {__html: item.text} }
              ></li>
            )
          })
          }
        </ul>
      </div>
    );
  }

  return null;
};

CaptionBox.propTypes = {
  content: PropTypes.object.isRequired,
  isDisplay: PropTypes.bool
};

CaptionBox.defaultProps = {
  content: {},
  isDisplay: true
};

export default CaptionBox;



// WEBPACK FOOTER //
// ./src/shared/AOForm/components/CaptionBox/index.js